import React, { useState } from 'react';
import { toast } from 'sonner';
import { useI18n } from '../i18n/context';
import { buildApiUrl } from '../config/api';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Card, CardContent, CardDescription, CardHeader } from './ui/card';

export default function ResetPasswordScreen({ token, onDone }) {
  const { t } = useI18n();
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  if (!token || !String(token).trim()) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white p-6 text-center">
        <p className="text-gray-700 max-w-md">{t('reset.invalidLink')}</p>
        <Button type="button" onClick={onDone}>
          {t('reset.toLogin')}
        </Button>
      </div>
    );
  }

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      toast.error(t('reset.passwordShort'));
      return;
    }
    if (password !== confirm) {
      toast.error(t('reset.passwordsMismatch'));
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(buildApiUrl('/auth/reset-password'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ token: token.trim(), password }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        toast.error(data.error || t('reset.fail'));
        return;
      }
      toast.success(data.message || t('reset.success'));
      onDone?.();
    } catch (err) {
      console.error(err);
      toast.error(t('reset.network'));
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="relative min-h-[100dvh] flex w-full items-center justify-center bg-black p-4">
        <Card className="w-full max-w-md rounded-2xl shadow-2xl bg-white">
          <CardHeader className="pt-6">
            <CardDescription className="text-gray-600 text-base">
              {t('reset.subtitle')}
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="reset-pass" className="text-gray-900">{t('reset.newPassword')}</Label>
                <Input
                  id="reset-pass"
                  type="password"
                  autoComplete="new-password"
                  className="h-11 bg-white border-gray-300 text-gray-900"
                  placeholder={t('auth.passwordMinPlaceholder')}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <div className="space-y-2">
                <Label htmlFor="reset-pass2" className="text-gray-900">{t('auth.confirmPassword')}</Label>
                <Input
                  id="reset-pass2"
                  type="password"
                  autoComplete="new-password"
                  className="h-11 bg-white border-gray-300 text-gray-900"
                  placeholder={t('auth.confirmPassword')}
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                />
              </div>
              <Button type="submit" disabled={loading} className="w-full h-11 bg-black text-white hover:bg-gray-800">
                {loading ? t('common.saving') : t('reset.submit')}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
);
}
